/**
 * @ngdoc services
 * @memberof mercury.modules.budget
 * @name Budgets
 * @description Data access servcei for Budget REST endpoints
 */
angular.module('mercury.modules.budget.worksheet')
.factory('Budgets', ["$http", "$q", "$resource", "settings", function($http, $q, $resource, settings) {
  var Budget = $resource(settings.mercHost + '/budgets/:id', {id: '@id'});

  /**
   * Get all Budgets for a given month and the full weeks ether side
   * @param  {Object} time ISO date within the target month
   * @return {Object} promise
   */
  function getMonth(time) {
    var monthStart = moment(time)
    .mStartOf('month')
    .mStartOf('week')
    .format('YYYY-MM-DD')

    var monthEnd = moment(time)
    .mStartOf('month')
    .add(1, 'month')
    .mStartOf('week')
    .add(1, 'week')
    .format('YYYY-MM-DD')

    return Budget.query({
      from: monthStart,
      to: monthEnd
    }).$promise
  }

  /**
   * Get all the budgets between the start and end dates
   *
   * @memberof Budgets
   * @param  {String} startTime Start of period to get budgets for
   * @param  {String} endTime end of period to get budgets for
   * @return {Object} promise
   */
  function getAll(startTime, endTime, companyId) {
    var deferred = $q.defer();
    var config = {params: {
      from: moment(startTime).format('YYYY-MM-DD'),
      to: moment(endTime).format('YYYY-MM-DD')
    }};

    // Optionally override the company-id header
    if (companyId) {
      config.headers = {
        'x-loaded-company-id': companyId,
        'x-loaded-suppress-subscription-errors': '1'
      };
    }

    $http.get(settings.mercHost + '/budgets', config)
    .then(function(result) {
      deferred.resolve(result.data);
    }, function(result) {
      deferred.reject(result.data);
    });

    return deferred.promise;
  }

  /**
   * Upsert changes to a budget
   *
   * @memberof Budgets
   * @param  {Object} budget New or updated budget model
   * @return {Object) promise
   */
  function update(budget) {
    if (budget.id) {
      return Budget.update(budget).$promise;
    } else {
      return Budget.save(budget).$promise;
    }
  }

  return {
    load: function() {
      return loadPromise;
    },
    getMonth: getMonth,
    getAll: getAll,
    update: update
  };

}]);
